import { render, staticRenderFns } from "./SaleVolumeBlock.vue?vue&type=template&id=6cc468ea&"
import script from "./SaleVolumeBlock.vue?vue&type=script&lang=ts&"
export * from "./SaleVolumeBlock.vue?vue&type=script&lang=ts&"
import style0 from "./SaleVolumeBlock.vue?vue&type=style&index=0&id=6cc468ea&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports